module.exports = __webpack_public_path__ + "img/logo.ad9eda59.png";